export default {
  'operation.manageAccount': 'Quản lí tài khoản',
  'operation.proxyAccount': 'Tài khoản uỷ quyền',
  'operation.resetPassword': 'Đặt lại mật khẩu',
  'operation.logout': 'Đăng xuất',
};
